import PhysicsWorld from '../../../logic/loop/PhysicsWorld'
import Player from '../../../logic/physics/Player'
import MGLoader from '../../../logic/saves/MGLoader'
import GameGlobals from '../GameGlobals'
import GamePage from '../GamePage'

export default function WASDMovement() {

	return (
		<GamePage
			onLoaded={(world: PhysicsWorld) => {
				const player = new Player({
					world,

					x: 150,
					y: 150
				})

				MGLoader.loadCasterFromFile('WASD_Movement.mg.json', player).then(() => {
					GameGlobals.setSelectedEntity(player)
				})

				world.add(player)

			}}
		/>
	)
}
